export interface AccountInformationForm {
  firstname: string;
  lastname: string;
  email: string;
  birthday: any;
  sex: string;
  profileImage: string | undefined;
}

export interface PasswordForm {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export interface FitnessDeviceConnection {
  id: string;
  name: string;
  connected: boolean;
  redirectUrl: string;
  logoUrl: string;
}

// TEMP (COE): Users connecting multiple watch/device sources (Polar, Garmin, Suunto,
// Coros, Strava) are seeing duplicate workouts. Until that is fixed, restrict web users
// to a single connected device at a time. Flip this back to `true` to restore
// multi-device support once the duplicate-workout bug is resolved.
export const ALLOW_MULTIPLE_DEVICE_CONNECTIONS = false;

export const emptyAccountInformationForm: AccountInformationForm = {
  firstname: '',
  lastname: '',
  email: '',
  birthday: '',
  sex: '',
  profileImage: undefined,
};

export const emptyPasswordForm: PasswordForm = {
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: '',
};

export const notificationControls = {
  column_1: [
    {
      value: 'email_invited_to_team',
      label: 'Email invitation to team',
    },
    {
      value: 'email_message_board_post',
      label: 'Email on Messages post',
    },
    {
      value: 'email_message_board_reply',
      label: 'Email on Messages reply',
    },
    {
      value: 'email_platform_update',
      label: 'Email on platform update',
    },
  ],
  column_2: [
    {
      value: 'push_platform_update',
      label: 'Notifications on platform update',
    },
    {
      value: 'push_watch_data_synced',
      label: 'Notifications when watch data has synced',
    },
    {
      value: 'push_message_board_post',
      label: 'Notifications when there is a new Messages post',
    },
    {
      value: 'push_message_board_reply',
      label: 'Notifications when there is a new Messages reply',
    },
  ],
};
